import assert from "assert";
import { Array, Boolean, Null, Partial, Record, String, Undefined } from "runtypes";
import { clean } from "./clean";
import { PERSONABLE_NETID_COLLECTION } from "./collections";
import { CourseName } from "./course";
import { SectionName } from "./section";
export const Name = Record({
  first: String,
  last: String,
  full: String
});
export const Person = Record({
  netID: String,
  ID: String,
  email: String,
  name: Name,
  roles: Array(String),
  memberOf: Array(String),
  sections: Array(SectionName),
  courses: Array(CourseName)
}).And(
  Partial({
    academicRoles: Array(String),
    college: Array(String),
    level: String,
    major: Array(String),
    department: String.Or(Null),
    admitted: String,
    role: String,
    current: Boolean
  })
);
export const SkinnyPerson = Record({
  email: String,
  name: Name
});
export const loadCurrentPerson = async (db, netID) => {
  return Person.Or(Undefined).check(
    clean(await db.collection(PERSONABLE_NETID_COLLECTION).findOne({ netID, left: { $exists: false } }))
  );
};
export const loadPerson = async (db, netID) => {
  return Person.Or(Undefined).check(clean(await db.collection(PERSONABLE_NETID_COLLECTION).findOne({ netID })));
};
export const emailToNetID = (email) => {
  assert(email.endsWith("@illinois.edu"));
  return email.split("@")[0];
};
export const personIsCSOrCSX = (person) => {
  if (person.major?.find((name) => name === "Computer Science")) {
    return "cs";
  } else if (person.major?.find(
    (name) => name.includes("Computer Science") || name.includes("ComputerScience") || name.includes("Computer Sci") || name.includes("Comp. Sci")
  )) {
    return "cs+x";
  } else {
    return "other";
  }
};
//# sourceMappingURL=person.js.map
